<template>
  <div class="seller-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Configurações &raquo; Lista de {{ termPlural }}</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto" v-if="canAdd">
                <router-link tag="a" class="btn btn-primary btn-sm" :to="'/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row class="mb-2">
            <b-col>
              <label class="cj-label">Nome</label>
              <b-form-input type="text" v-model="searchBy"></b-form-input>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getDirectingSectors(1)"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de {{ termPlural }}</p>
                  <p class="title"><small>{{ pagination.total }} {{ termPlural }} cadastrad{{ letter }}s</small></p>
                </div>
              </div>
              <div class="content">

                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="line-add" v-if="canAdd">
                      <td class="text-center">
                        <router-link tag="a" class="btn btn-block btn-sm btn-add-new" :to="'/'+url+'/'+newTerm"><i class="far fa-plus-circle"></i> Adicionar nov{{ letter}} {{termSingular}}</router-link>
                      </td>
                    </tr>
                    <router-link tag="tr" :to="'/'+url+'/'+directingSector.id" v-for="directingSector in directingSectors" :key="directingSector.id">
                      <td>{{ directingSector.name }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="searchBy == '' && directingSectors.length == 0" class="text-center sub-title">Você ainda não possui nenhum{{ (letter != 'o')?letter:'' }} {{ termSingular }} cadastrad{{ letter }}.</p>
                <p v-if="searchBy != '' && directingSectors.length == 0" class="text-center sub-title">A sua busca por {{ termSingular }} com o termo "{{ searchBy }}" não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getDirectingSectors"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'setor',
        termPlural: 'setores',
        url: 'configuracoes/setores',
        letter: 'o',
        newTerm: 'cadastrar-setor',
        module: 'directing-sectors',

        user: null,

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        directingSectors: [],

        searchBy: ''
      }
    },
    mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false || !this.user.person.client.directing_enabled) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.getDirectingSectors(this.pagination.currentPage);
    },
    methods: {
      getDirectingSectors(page) {
        this.api.getDirectingSectors({name: this.searchBy, page: page}).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.directingSectors = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Directing Area', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar os convênios da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Directing Area', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .seller-list {
    padding: 20px 0;

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }
        }
      }
    }
  }
</style>
